/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const authApIgetClaim = /* GraphQL */ `
  query AuthApIgetClaim($code: String!) {
    authAPIgetClaim(code: $code) {
      jwt
      sso
    }
  }
`;
export const userApIgetSession = /* GraphQL */ `
  query UserApIgetSession($sso: String!) {
    userAPIgetSession(sso: $sso) {
      adminStatus
      adminEnvRedirect {
        env
        result
      }
      login {
        status
        resultCount
        id
        password
        firstPage
        isDisabled
        resourceId
        saveUserName
        login
        passworedExpired
        attemptsToLog
        matchPassword
        userBlocked
        identityId
      }
      resourceCollectionId
      configuration {
        date
        fromDateUnassign
        toDateUnassign
        userId
        companyId
        collectionId
        format
        employeeType
        separation
        assignments
        orderBy
        mealHours
        penalties
        dayType
        tourHours
        filter
        sCollId
        resourceType
        createDateTime
        fndUserName
        fndResourceName
        fndClientName
        tourDepartmentId
        fndSSO
        fndFullVersion
        onlyDT_DOR
        jeHours
        placementSize
        colorScheme
        susJobNumberSize
        susClientProjectSize
        susServiceSize
        susAssignmentTimeSize
        susJobTitleSize
        susJobCitySize
        susJobStateSize
        susJobBookingSize
        susRequestorSize
        susCreateTimeSize
        susUpdateTimeSize
        susNumberOfDaysSize
        susMeetTimeSize
        susBureausList
        susStatesList
        susClientsList
        assignmentTitle
        statesList
        bureausList
        audibleAlerts
        susFacilityPerson
        placementColumnOrder
        rpssott
        rIdForAssignments
        rIdForVacation
      }
      securityLevels {
        resultCount
        branches
        divisions
        departments
        resources
        groups
        services
        packages
        serviceCollections
        resourceCollections
        dayTypes
        earningCodes
        penalties
        payTransactions
        unions
        contracts
        rulesGroups
        rulesGroupsInterface
        cfeFeedSchedule
        users
        securityGroups
        logOutTime
        emailGroups
        companies
        timeZones
        gmtOffsets
        off
        resourceAllocation
        rindClient
        newClient
        findProject
        newProject
        findRequestRequestor
        findRequestDate
        findRequestService
        findRequestStatus
        findRequestCancel
        findRequestModified
        newRequest
        copyRequest
        showBudget
        editMultiRequests
        requestsProject
        dubRequest
        editRequestForm
        fieldCrewRequest
        fieldCrewScheduler
        fcrAssignedCrews
        copyFieldCrew
        fieldCrewDraft
        fieldCrewRevision
        findFieldCrewResources
        fieldCrewClients
        fieldCrewServices
        fieldCrewEquipment
        editUI
        indicators
        holidays
        detailedRequest
        findTour
        newTour
        interfacesControl
        absenceRequests
        absenceReport
        vacationAdditions
        resourceDayTypes
        showOnCalendar
        showOnMultCalendar
        allowDeletingTour
        changeAbsencesResource
        assignments
        changeAssignmentsResource
        scheduleMenu
        rpSSO
        rpHomePhoneNumber
        rpAddress
        rpEAddress
        rpSalaryLevel
        rpDateOfBirth
        rpPassportNumber
        rpStartDate
        sso
        rpLogTab
        ssoStatusIREnable
        tourSalaryLevel
        scheduleView
        unassignsView
        resourceInfo
        showAllPostings
        updateComment
        sameResource
        statusRemark
        status
        changeDayType
        daysOffRulesGroups
        training
        costingToursAssignments
        viewedAssignments
        remark
        schedulerFeatures
        deleteRequest
        upgrade
        generalMenu
        reportsMenu
        setupMenu
        requestLog
        tourLog
        updateMealHours
        clientTypes
        nonBillableCT
        usePenalties
        viewPrices
        dayTypesAdmin
        employeeTypes
        companyDT
        library
        states
        bureaus
        markets
        tour
        defaultPriceMethod
        resourceOrder
        defaultResourceOrder
        cancelMode
        notBilledJE
        cancelRequest
        assignmentStatus
        priceMethod
        budgetCodeOverride
        clientsWithSameBudget
        mealTimeInRequest
        overTime
        messages
        oldSharcReport
        viewedPostingsReport
        noPostingsReport
        newTourDayType
        updateTourHours
        updateAssignmentHours
        printSchedule
        scheduleExcelPhone
        lastPostings
        assignmentComment
        scheduleMail
        deleteDaysOffRequest
        daysAvailable
        unapproveTour
        dddToRCFromJob
        requestStatus
        simulation
        salaryLevel
        addDates
        updateRequest
        mySchedule
        changeScheduleDates
        notificationReport
        jobDatesOptions
        jobClient
        servicesOrder
        requestDetails
        copySchedule
        slMap
        penaltyCost
        billPenalty
        rcDelete
        scDelete
        updateSalaryLevelInApprovals
        updateActivityCodeInApprovals
        clientDelete
        salaryLevelInfoInReport
        messagesToAllUsers
        stormEmail
        administration
        scheduleData
        liquidation
        rulesGroupsReport
        unlimitedReport
        applyChanges
        updateSecurityGroups
        changeClientInJobDates
        approvals
        approveTours
        approveJEs
        approveToursInSchedule
        approveJEsInSchedule
        resourcesPersonnel
        resourcesServices
        resourcesNotifications
        resourcesTraining
        resourcesPasses
        resourcesAbsence
        resourcesGeneral
        resourcesEmployee
        resourcesAdditionalInfo
        resourcesMarket
        userLogin
        userPassword
        lastFourDigSSN
        otherCompanyUsers
        editMultiGroups
        userLogTab
        importMarketService
        userResourceCollections
        editDORFromSchedule
        resourcesReports
        importDayTypes
        deleteJobsInAddDates
        userRelatedBranches
        userDetails
        scheduleTTSalaryLevel
        scheduleTTClient
        scheduleTTBudgetCode
        scheduleTTComments
        scheduleTTService
        absenceIndication
        tourApproverComments
        jeApproverComments
        jeDescription
        unassignedServices
        presentation
        findDepartmentS
        findClientS
        findRequestS
        simulationS
        clientInfo
        projectInfo
        noneBillableClient
        approvalsSubmit
        quate
        invoice
        dayTypeContractInfo
        daysOffReport
        daysOffRequestReport
        simulationReport
        clientCostingReport
        costReportByDep
        resourceDisable
        goodNighted
        otTypeReasonG
        salaryActivity
        sbOrder
        goodNightedSchedule
        postDailies
        otTypeReasonS
        placeAssignment
        postSchedule
        freelancerCal
        workflow
        budgetPlaning
        scenesManager
        companyMenu
        vpUser
        vpAdmin
        accessibleSecurityGroups
        extrasMenu
        extrasAddUsers
        extraProjectsMenu
        extraTasksMenu
        userTaskUsers
        userTaskProjects
        activityCodePrice
        deletedToursReport
        toursChangesReport
        cfeTransactionsReport
        toursRejectedReport
        equipmentUsageReport
        crewEquipmentPaceReport
        datelinePacingReport
        password
        findCostObject
        wbsCapital
        detailedRequestDatesAvailable
        msnbcFacilitiesReport
        tkComment
        salaryLevelUpgrade
        activityType
        assignmentUpgradeFlag
        baseOverride
        tourUpgradeFlag
        assignmentSalaryLevelUpgrade
        tourSalaryUpgradeAccounting
        rsSalaryLevel
        costReportActivityTypes
        costReportTKComments
        costReportTourCosts
        effectiveDateForSeniority
        rcSendTK
        rcSendSAP
        tourHyphenate
        massiveApprovalsSalary
        activityFlag
        costReportDayType
        resourceHourlyActivityRate
        tourHourlyActivityRate
        assignmentHourlyActivityRate
        servicesHourlyActivityRate
        accountingHourlyActivityRate
        enterAdjustedHire
        editAdjustedHire
        employeeResourceCollections
        billIndicator
        costingReportExpPTCost
        copyPaymentInfo
        resourceInfoSSO
        copyCostObject
        harEdition
        showActTypeRates
        secondLevelApprovals
        showOTReason
        dayTypesTab
        payTransactionsTab
        dayTypeAll
        payTransactionAll
        dtTabUnapprovedDOR
        tApproverCommentG
        jeApproverCommentG
        disableApprovedComments
        daysOffEmail
        myComment
        tourCostCenter
        tourWBSE
        secTTReqNum
        myTourComment
        myAssignmentComment
        myScheduleCostObject
        myScheduleAssignmentCostObject
        laborFacilityInfo
        scheduleTourContract
        scheduleJEContract
      }
      userDemographics {
        name
        firstName
        lastName
        email
        isDisabled
      }
      mobileSecurity {
        canEdit
      }
      instantMessages {
        messages {
          message
        }
      }
    }
  }
`;
export const userApIgetBranch = /* GraphQL */ `
  query UserApIgetBranch($userId: Int!) {
    userAPIgetBranch(userId: $userId) {
      status
      userBranchId
      userTimeZoneId
      companyName
      companyLogo
    }
  }
`;
export const userApIgetUpdatingUser = /* GraphQL */ `
  query UserApIgetUpdatingUser($userId: Int!) {
    userAPIgetUpdatingUser(userId: $userId) {
      status
      counter
      data {
        rowId
        name
        firstName
        lastName
        isDisabled
        resourceId
        email
        updatingUserId
        sso
        copyComment
      }
    }
  }
`;
export const scheduleApIgetPostedSchedules = /* GraphQL */ `
  query ScheduleApIgetPostedSchedules(
    $startDate: String!
    $scheduleFormat: Int!
    $postedId: Int!
  ) {
    scheduleAPIgetPostedSchedules(
      startDate: $startDate
      scheduleFormat: $scheduleFormat
      postedId: $postedId
    ) {
      userName
      savedDate
      startDate
      resourceCollectionId
      postedSchedule {
        rId
        class
        name
        empCat
        rType
        dayTypes {
          rdtId
          dayTypeName
          dayStart
          dayTypeComment
          myDayTypeComment
          title
          dayOff {
            dorId
            abbreviation
            title
            status
            startTime
            endTime
            dayTypeComment
            myDayTypeComment
            showCostObjectId
            costCenter
            wbse
          }
          dayOffRequest {
            dorId
            dayOffRequestTitle
            status
            startTime
            endTime
            dayTypeComment
            myDayTypeComment
          }
          tour {
            tourId
            abbreviation
            startTime
            duration
            remainDuration
            notificationComment
            tourComment
            myTourComment
            remoteIndicator
            tourIndicators {
              name
              code
            }
            isApproved
            tourPayTransactions
            meal {
              mealId
              mealTime
              mealEndTime
              red
              isApproved
            }
            overTime {
              startTime
              endTime
            }
            assignments {
              jeId
              startTime
              endTime
              service
              activityType
              requestNumber
              jobId
              costObject
              costObjectNumber
              description
              myAssignmentComment
              comment
              jeStatus
              isApproved
              mqsStartTime
              mqsEndTime
              overtimeReason
              assignmentContract
            }
            tourContract
            costCenter
            wbse
          }
          assignment {
            jeId
            startTime
            endTime
            service
            activityType
            requestNumber
            jobId
            costObject
            costObjectNumber
            description
            myAssignmentComment
            comment
            jeStatus
            isApproved
            mqsStartTime
            mqsEndTime
            overtimeReason
            assignmentContract
          }
        }
      }
      JSONData {
        rId
        name
        empCat
        rType
        dayOffRequest {
          dorId
          dayTypeName
          dayOffRequestTitle
        }
        dayTypes {
          rdtId
          dorId
          dayTypeName
          title
        }
        assignments {
          jeId
          startTime
          endTime
          serviceName
        }
        tour {
          tourId
          abbreviation
          startTime
          endTime
          assignments {
            jeId
            startTime
            endTime
            serviceName
          }
          meal {
            mealId
            startTime
            endTime
          }
        }
      }
    }
  }
`;
export const scheduleApIgetLiveSchedules = /* GraphQL */ `
  query ScheduleApIgetLiveSchedules(
    $startDate: String!
    $scheduleFormat: Int!
    $resourceCollectionId: Int!
    $userId: Int!
    $resourceId: Int!
    $scheduleView: Int!
  ) {
    scheduleAPIgetLiveSchedules(
      startDate: $startDate
      scheduleFormat: $scheduleFormat
      resourceCollectionId: $resourceCollectionId
      userId: $userId
      resourceId: $resourceId
      scheduleView: $scheduleView
    ) {
      liveSchedule {
        labourSchedule {
          airport
          class
          color
          costCenter
          costCenterId
          costCenterName
          divisionName
          empCat
          empType
          facilityId
          homePhone
          inFacility
          mobilePhone
          name
          orderIndex
          personalMail
          rId
          rType
          sso
          workEmail
          dayTypes {
            dayKind
            dayRequestId
            dayStart
            dayTypeId
            dayTypeName
            dayTypeComment
            myDayTypeComment
            remoteDay
            remoteIndicator
            resourceId
            rdtId
            title
            dayOff {
              abbreviation
              approverComment
              dorId
              endTime
              isApproved
              payTransaction
              secondLvlApproval
              startTime
              title
              toBeDeleted
              trainingDay
              dayTypeComment
              myDayTypeComment
              showCostObjectId
              wbse
              costCenter
            }
            dayOffRequest {
              abbreviation
              approved
              title
              dorId
              startTime
              endTime
              isApproved
              dayTypeComment
              myDayTypeComment
            }
            tour {
              abbreviation
              approverComment
              chargeBackCode
              costCenter
              costCenterId
              duration
              endTime
              infoOnly
              isSimulation
              jobSalaryUpgrade
              mark
              markColor
              tourComment
              isApproved
              notificationComment
              reconciled
              remainDuration
              salaryLevel
              secondLvlApproval
              smsStatus
              startTime
              timeEnd
              timeStart
              timeZoneId
              tourColor
              myTourComment
              tourId
              tourNotification
              trainingDay
              userTZId
              wbse
              tourContract
              assignments {
                activityType
                approverComment
                budgetCode
                cancelMode
                clientName
                comment
                costObjectId
                costObject
                costObjectNumber
                isApproved
                costObjectType
                costObjectTypeId
                costOnFacility
                dayStart
                description
                duration
                endTime
                hiatus
                isGoodNighted
                isSimulation
                jeId
                jobId
                myAssignmentComment
                overtimeReason
                overtimeType
                projectName
                realId
                reconciled
                relatedResource
                relatedServiceId
                requestNumber
                resourceId
                rightNow
                salaryLevel
                sbOrder
                secondLvlApproval
                service
                startTime
                startTimeGn
                status
                timeEnd
                timeStart
                timeZone
                timeZoneId
                title
                tourId
                upgrade
                altResource
                altType
                assignmentContract
              }
              meal {
                dayStart
                duration
                mealId
                mealTime
                mealEndTime
                reconciled
                resourceId
                timeEnd
                timeStart
                tourId
                red
                isApproved
              }
              overTime {
                startTime
                endTime
              }
              tourIndicators {
                code
                name
                resourceId
                tourId
                tourIndicatorId
              }
              tourPayTransactions {
                code
                hourUnits
                inContract
                kind
                name
                otLength
                resourceId
                tourId
                tourPayTransactionId
                usage
                waived
              }
            }
            assignment {
              activityType
              approverComment
              budgetCode
              cancelMode
              clientName
              comment
              costObjectId
              costObject
              costObjectNumber
              isApproved
              costObjectType
              costObjectTypeId
              costOnFacility
              dayStart
              description
              duration
              endTime
              hiatus
              isGoodNighted
              isSimulation
              jeId
              jobId
              myAssignmentComment
              overtimeReason
              overtimeType
              projectName
              realId
              reconciled
              relatedResource
              relatedServiceId
              requestNumber
              resourceId
              rightNow
              salaryLevel
              sbOrder
              secondLvlApproval
              service
              startTime
              startTimeGn
              status
              timeEnd
              timeStart
              timeZone
              timeZoneId
              title
              tourId
              upgrade
              altResource
              altType
              assignmentContract
            }
          }
        }
        facilitySchedule {
          airport
          class
          color
          costCenter
          costCenterId
          costCenterName
          divisionName
          empCat
          empType
          facilityId
          homePhone
          inFacility
          mobilePhone
          name
          orderIndex
          personalMail
          rId
          rType
          sso
          workEmail
          dayTypes {
            dayKind
            dayRequestId
            dayStart
            dayTypeId
            dayTypeName
            dayTypeComment
            myDayTypeComment
            remoteDay
            remoteIndicator
            resourceId
            rdtId
            title
            dayOff {
              abbreviation
              approverComment
              dorId
              endTime
              isApproved
              payTransaction
              secondLvlApproval
              startTime
              title
              toBeDeleted
              trainingDay
              dayTypeComment
              myDayTypeComment
            }
            dayOffRequest {
              abbreviation
              approved
              title
              dorId
              startTime
              endTime
              isApproved
              dayTypeComment
              myDayTypeComment
            }
            tour {
              abbreviation
              approverComment
              chargeBackCode
              costCenter
              costCenterId
              duration
              endTime
              infoOnly
              isSimulation
              jobSalaryUpgrade
              mark
              markColor
              tourComment
              isApproved
              notificationComment
              reconciled
              remainDuration
              salaryLevel
              secondLvlApproval
              smsStatus
              startTime
              timeEnd
              timeStart
              timeZoneId
              tourColor
              myTourComment
              tourId
              tourNotification
              trainingDay
              userTZId
              wbse
              tourContract
              assignments {
                activityType
                approverComment
                budgetCode
                cancelMode
                clientName
                comment
                costObjectId
                costObject
                costObjectNumber
                isApproved
                costObjectType
                costObjectTypeId
                costOnFacility
                dayStart
                description
                duration
                endTime
                hiatus
                isGoodNighted
                isSimulation
                jeId
                jobId
                myAssignmentComment
                overtimeReason
                overtimeType
                projectName
                realId
                reconciled
                relatedResource
                relatedServiceId
                requestNumber
                resourceId
                rightNow
                salaryLevel
                sbOrder
                secondLvlApproval
                service
                startTime
                startTimeGn
                status
                timeEnd
                timeStart
                timeZone
                timeZoneId
                title
                tourId
                upgrade
                altResource
                altType
                assignmentContract
              }
              meal {
                dayStart
                duration
                mealId
                mealTime
                mealEndTime
                reconciled
                resourceId
                timeEnd
                timeStart
                tourId
                red
                isApproved
              }
              overTime {
                startTime
                endTime
              }
              tourIndicators {
                code
                name
                resourceId
                tourId
                tourIndicatorId
              }
              tourPayTransactions {
                code
                hourUnits
                inContract
                kind
                name
                otLength
                resourceId
                tourId
                tourPayTransactionId
                usage
                waived
              }
            }
            assignment {
              activityType
              approverComment
              budgetCode
              cancelMode
              clientName
              comment
              costObjectId
              costObject
              costObjectNumber
              isApproved
              costObjectType
              costObjectTypeId
              costOnFacility
              dayStart
              description
              duration
              endTime
              hiatus
              isGoodNighted
              isSimulation
              jeId
              jobId
              myAssignmentComment
              overtimeReason
              overtimeType
              projectName
              realId
              reconciled
              relatedResource
              relatedServiceId
              requestNumber
              resourceId
              rightNow
              salaryLevel
              sbOrder
              secondLvlApproval
              service
              startTime
              startTimeGn
              status
              timeEnd
              timeStart
              timeZone
              timeZoneId
              title
              tourId
              upgrade
              altResource
              altType
            }
          }
        }
      }
    }
  }
`;
export const scheduleApIgetPostedSchedulesList = /* GraphQL */ `
  query ScheduleApIgetPostedSchedulesList($resourceId: Int!) {
    scheduleAPIgetPostedSchedulesList(resourceId: $resourceId) {
      status
      resultCount
      postedSevenDayId
      savedMd7
      postedNineDayId
      savedMd9
      postedDayOneId
      postedDayTwoId
      postedDayThreeId
      postedDayFourId
      postedDayFiveId
      postedDaySixId
      postedDaySevenId
      postedDayEightId
      postedTwoDaysToday
      postedTwoDaysTomorrow
    }
  }
`;
export const scheduleApIgetDetailedSchedules = /* GraphQL */ `
  query ScheduleApIgetDetailedSchedules(
    $startDate: String!
    $endDate: String!
    $resourceId: Int!
    $userId: Int!
  ) {
    scheduleAPIgetDetailedSchedules(
      startDate: $startDate
      endDate: $endDate
      resourceId: $resourceId
      userId: $userId
    ) {
      detailedSchedule {
        approved
        comment
        comment15
        dayType
        jobSalaryUpgrade
        myRdtComment
        notification
        postTK
        rdtComment
        rdtDate
        rdtId
        salaryLevel
        timeEnd
        timeStart
        tourId
        RDTAllowComment
        startTimeH
        endTimeH
        costCenter
        wbse
        showRdtCostObject
        rdtCostCenter
        rdtwsbe
        serviceOrders {
          approved
          approverComment
          clientName
          comment
          employeeComment
          endDate
          gTitle
          jobId
          jobNumber
          salaryLevel
          schedulerComment
          serviceId
          serviceName
          startDate
          status
          tourId
          viewed
          allowChangeHours
          startTimeH
          endTimeH
          costCenter
          costObject
        }
        meals {
          approved
          mealEnd
          mealId
          mealStart
          tourId
          startTimeH
          endTimeH
        }
        payTransactions {
          code
          tourId
        }
        indicators {
          name
          tourId
        }
      }
    }
  }
`;
export const scheduleApIgetPreviousPostings = /* GraphQL */ `
  query ScheduleApIgetPreviousPostings($resourceId: Int!) {
    scheduleAPIgetPreviousPostings(resourceId: $resourceId) {
      status
      resultCount
      previous7Days {
        id
        date
      }
      previous9Days {
        id
        date
      }
    }
  }
`;
export const scheduleApIgetResourceCollectionInformation = /* GraphQL */ `
  query ScheduleApIgetResourceCollectionInformation(
    $resourceCollectionId: Int!
  ) {
    scheduleAPIgetResourceCollectionInformation(
      resourceCollectionId: $resourceCollectionId
    ) {
      status
      counter
      data {
        id
        name
      }
    }
  }
`;
export const resourceApIgetResource = /* GraphQL */ `
  query ResourceApIgetResource(
    $name: String!
    $sso: String
    $withDisabled: Boolean
  ) {
    resourceAPIgetResource(
      name: $name
      sso: $sso
      withDisabled: $withDisabled
    ) {
      status
      resultCount
      counter
      resources {
        rowId
        id
        dName
        name
        costCenterId
        userId
        resourceType
        isDisabled
        phone1
      }
    }
  }
`;
export const resourceApIgetResourceCollection = /* GraphQL */ `
  query ResourceApIgetResourceCollection($userId: Int!, $branchId: Int!) {
    resourceAPIgetResourceCollection(userId: $userId, branchId: $branchId) {
      status
      counter
      resources {
        rowId
        id
        dName
        name
        costCenterId
        userId
        resourceType
        isDisabled
        phone1
      }
    }
  }
`;
export const resourceApIgetResourcePersonnelData = /* GraphQL */ `
  query ResourceApIgetResourcePersonnelData($resourceId: Int!) {
    resourceAPIgetResourcePersonnelData(resourceId: $resourceId) {
      status
      counter
      data {
        resourceId
        isDisabled
        name
        departmentId
        branchId
        divisionId
        resourceType
        unionId
        contractId
        rulesGRP
        hourlyActivityFlag
        rate
        jobSalaryId
      }
    }
  }
`;
export const resourceApIgetResourceByDates = /* GraphQL */ `
  query ResourceApIgetResourceByDates(
    $branchId: Int!
    $servicesList: String!
    $startTime: String!
    $endTime: String!
    $jobElementId: Int!
    $showPrice: Boolean!
    $priceMethod: Int!
    $orderBy: Int!
    $relativeServiceId: Int!
    $resourceType: Int!
  ) {
    resourceAPIgetResourceByDates(
      branchId: $branchId
      servicesList: $servicesList
      startTime: $startTime
      endTime: $endTime
      jobElementId: $jobElementId
      showPrice: $showPrice
      priceMethod: $priceMethod
      orderBy: $orderBy
      relativeServiceId: $relativeServiceId
      resourceType: $resourceType
    ) {
      status
      counter
      data {
        id
        name
        relativeServiceId
        salaryLevelId
        resourceType
        departmentName
        departmentId
        color
        upgrade
        isDisabled
        availability
        lat
        long
        city
        state
        salaryhourlyRate
        salaryLevelCode
        defaultRate
      }
    }
  }
`;
export const resourceApIgetResourceContactInfo = /* GraphQL */ `
  query ResourceApIgetResourceContactInfo(
    $resourceId: Int!
    $startDate: String!
  ) {
    resourceAPIgetResourceContactInfo(
      resourceId: $resourceId
      startDate: $startDate
    ) {
      status
      counter
      data {
        activityService {
          ResourceId
          ServiceName
          BranchName
          BranchId
        }
        activityType
        airport
        cellularPhone
        departmentId
        departmentName
        divisionName
        empCat
        faxPhone
        homePhone
        id
        name
        otherPhone
        pagerPhone
        pagerPin
        privateEmail
        resourceType
        sso
        workEmail
        workPhone
        workPhoneExt
      }
    }
  }
`;
export const dayTypeApIgetDayTypeCalendar = /* GraphQL */ `
  query DayTypeApIgetDayTypeCalendar(
    $resourceId: Int!
    $year: Int!
    $month: Int!
    $showFutureDays: Boolean!
    $userId: Int!
  ) {
    dayTypeAPIgetDayTypeCalendar(
      resourceId: $resourceId
      year: $year
      month: $month
      showFutureDays: $showFutureDays
      userId: $userId
    ) {
      resourceDayTypesByYear {
        status
        counter
        resourceDayTypes {
          resourceDayTypeId
          date
          dayTypeId
          dayTypeCode
          sickPay
          allowTourScheduling
          tourId
          dayKind
          comment
          myComment
          showInCalendar
          dayTypeName
        }
      }
      dayTypeRequestsByYear {
        status
        counter
        dayTypeRequests {
          dayTypeRequestId
          fromDate
          toDate
          status
          shortStatus
          dayTypeCode
          dayTypeName
          allowTourScheduling
          approvalNeeded
          myComment
          statusComment,
          dayTypeId
        }
      }
      dayTypeSummariesByYear {
        status
        counter
        dayTypeSummaries {
          resourceName
          scheduledDays {
            dayTypeName
            dayTypeCode
            total
          }
          timekeeperDays {
            dayTypeName
            dayTypeCode
            total
          }
          UnapprovedRequestedOff {
            dayTypeName
            dayTypeCode
            total
          }
        }
      }
    }
  }
`;
export const dayTypeApIgetDayTypeSecurity = /* GraphQL */ `
  query DayTypeApIgetDayTypeSecurity($userId: Int!, $dayTypeId: Int!) {
    dayTypeAPIgetDayTypeSecurity(userId: $userId, dayTypeId: $dayTypeId) {
      status
      dayTypeId
      userDayTypeAccess
    }
  }
`;
export const dayTypeApIgetMyCommentFromDayType = /* GraphQL */ `
  query DayTypeApIgetMyCommentFromDayType(
    $resourceId: Int!
    $date: String!
    $userId: Int!
  ) {
    dayTypeAPIgetMyCommentFromDayType(
      resourceId: $resourceId
      date: $date
      userId: $userId
    ) {
      status
      myComment
    }
  }
`;
export const dayTypeApIgetDayTypeById = /* GraphQL */ `
  query DayTypeApIgetDayTypeById($dayTypeId: Int!) {
    dayTypeAPIgetDayTypeById(dayTypeId: $dayTypeId) {
      status
      counter
      data {
        dayTypeId
        isDisabled
        dayTypeName
        dayTypeCode
        CFEDayCode
        goldenTime
        excessiveTime
        dayKind
        sortOrder
        allowTourScheduling
        approvalNeeded
        sickTime
        isDefault
        personalBusiness
        remote
        showInRequest
        requestedOff
        training
        include
        needsRule
        dayTypeDescription
        showInSchedule
        showInCalendar
        tourColor
        sendEmail
        sendEmailTaken
        vacationPlanner
        onlyDayInfoSchedule
        showResourceComment
        consecutiveDays
        forceTour
        company
        penaltyId
        allowTourExtension
        TKDayCode
        payTransactionId
        sendToTK
        requireActHours
        updatingUserId
        updatingDateTime
        autoApprovedForTK
        countOTWeek
        isPaid
        showInCostingReport
      }
    }
  }
`;
export const dayTypeApIgetResourceDayTypeByDate = /* GraphQL */ `
  query DayTypeApIgetResourceDayTypeByDate($resourceId: Int!, $date: String!) {
    dayTypeAPIgetResourceDayTypeByDate(resourceId: $resourceId, date: $date) {
      status
      counter
      data {
        resourceDayTypeId
        isDisabled
        resourceId
        date
        dayTypeId
        scheduledDayTypeId
        approved
        approvedTimeStamp
        comment
        myComment
        daysRequestId
        originalDayTypeId
        createdDateTime
        updatingDateTime
        updatingUserId
        unionId
        contractId
        contractRulesGroupId
        contractRuleId
        salaryLevelId
        IPAddress
        TKComment
        addAuto
        postTK
        jobSalaryId
        sentDate
        rate
        hourlyActivityRateFlag
        jobSalaryUpgradeId
      }
    }
  }
`;
export const dayTypeApIgetResourceDayTypeById = /* GraphQL */ `
  query DayTypeApIgetResourceDayTypeById($resourceDayTypeId: String!) {
    dayTypeAPIgetResourceDayTypeById(resourceDayTypeId: $resourceDayTypeId) {
      status
      counter
      data {
        resourceDayTypeId
        isDisabled
        resourceId
        date
        dayTypeId
        scheduledDayTypeId
        approved
        approvedTimeStamp
        comment
        myComment
        daysRequestId
        originalDayTypeId
        createdDateTime
        updatingDateTime
        updatingUserId
        unionId
        contractId
        contractRulesGroupId
        contractRuleId
        salaryLevelId
        IPAddress
        TKComment
        addAuto
        postTK
        jobSalaryId
        sentDate
        rate
        hourlyActivityRateFlag
        jobSalaryUpgradeId
      }
    }
  }
`;
export const dayTypeApIgetDayTypesAll = /* GraphQL */ `
  query DayTypeApIgetDayTypesAll(
    $isApprover: Boolean!
    $resourceId: Int!
    $date: String!
    $withForceTour: Boolean!
    $userId: Int
  ) {
    dayTypeAPIgetDayTypesAll(
      isApprover: $isApprover
      resourceId: $resourceId
      date: $date
      withForceTour: $withForceTour
      userId: $userId
    ) {
      status
      counter
      dayTypes {
        dayTypeId
        isDisabled
        dayTypeName
        dayTypeCode
        CFEDayCode
        goldenTime
        excessiveTime
        dayKind
        sortOrder
        allowTourScheduling
        approvalNeeded
        sickTime
        isDefault
        personalBusiness
        remote
        showInRequest
        requestedOff
        training
        include
        needsRule
        dayTypeDescription
        showInSchedule
        showInCalendar
        tourColor
        sendEmail
        sendEmailTaken
        vacationPlanner
        onlyDayInfoSchedule
        showResourceComment
        consecutiveDays
        forceTour
        company
        penaltyId
        allowTourExtension
        TKDayCode
        payTransactionId
        sendToTK
        requireActHours
        updatingUserId
        updatingDateTime
        autoApprovedForTK
        countOTWeek
        isPaid
        showInCostingReport
        overrideDayType
      }
    }
  }
`;
export const dayTypeApIgetDayTypesByResourceDayRule = /* GraphQL */ `
  query DayTypeApIgetDayTypesByResourceDayRule(
    $resourceId: Int!
    $userId: Int!
  ) {
    dayTypeAPIgetDayTypesByResourceDayRule(
      resourceId: $resourceId
      userId: $userId
    ) {
      status
      counter
      dayTypes {
        dayTypeId
        isDisabled
        dayTypeName
        dayTypeCode
        CFEDayCode
        goldenTime
        excessiveTime
        dayKind
        sortOrder
        allowTourScheduling
        approvalNeeded
        sickTime
        isDefault
        personalBusiness
        remote
        showInRequest
        requestedOff
        training
        include
        needsRule
        dayTypeDescription
        showInSchedule
        showInCalendar
        tourColor
        sendEmail
        sendEmailTaken
        vacationPlanner
        onlyDayInfoSchedule
        showResourceComment
        consecutiveDays
        forceTour
        company
        penaltyId
        allowTourExtension
        TKDayCode
        payTransactionId
        sendToTK
        requireActHours
        updatingUserId
        updatingDateTime
        autoApprovedForTK
        countOTWeek
        isPaid
        showInCostingReport
      }
    }
  }
`;
export const dayTypeApIgetDayTypesAllowingTourScheduling = /* GraphQL */ `
  query DayTypeApIgetDayTypesAllowingTourScheduling(
    $isApprover: Boolean!
    $resourceId: Int!
    $date: String!
    $dayTypeId: Int!
    $withForceTour: Boolean!
  ) {
    dayTypeAPIgetDayTypesAllowingTourScheduling(
      isApprover: $isApprover
      resourceId: $resourceId
      date: $date
      dayTypeId: $dayTypeId
      withForceTour: $withForceTour
    ) {
      status
      counter
      dayTypes {
        dayTypeId
        isDisabled
        dayTypeName
        dayTypeCode
        CFEDayCode
        goldenTime
        excessiveTime
        dayKind
        sortOrder
        allowTourScheduling
        approvalNeeded
        sickTime
        isDefault
        personalBusiness
        remote
        showInRequest
        requestedOff
        training
        include
        needsRule
        dayTypeDescription
        showInSchedule
        showInCalendar
        tourColor
        sendEmail
        sendEmailTaken
        vacationPlanner
        onlyDayInfoSchedule
        showResourceComment
        consecutiveDays
        forceTour
        company
        penaltyId
        allowTourExtension
        TKDayCode
        payTransactionId
        sendToTK
        requireActHours
        updatingUserId
        updatingDateTime
        autoApprovedForTK
        countOTWeek
        isPaid
        showInCostingReport
      }
    }
  }
`;
export const dayTypeApIgetDayTypeRequestsByYear = /* GraphQL */ `
  query DayTypeApIgetDayTypeRequestsByYear(
    $resourceId: Int!
    $showInRequest: Boolean!
    $year: Int!
    $month: Int!
  ) {
    dayTypeAPIgetDayTypeRequestsByYear(
      resourceId: $resourceId
      showInRequest: $showInRequest
      year: $year
      month: $month
    ) {
      status
      counter
      dayTypeRequests {
        dayTypeRequestId
        fromDate
        toDate
        status
        shortStatus
        dayTypeCode
        dayTypeName
        allowTourScheduling
        approvalNeeded
        myComment
        statusComment
        dayTypeId
      }
    }
  }
`;
export const dayTypeApIgetDayTypeRequestById = /* GraphQL */ `
  query DayTypeApIgetDayTypeRequestById($id: Int!) {
    dayTypeAPIgetDayTypeRequestById(id: $id) {
      status
      counter
      dayTypeRequests {
        dayTypeRequestId
        dayTypeId
        fromDate
        toDate
        fromTime
        toTime
        remark
        requestDate
        resourceId
        status
        statusChangeDateTime
        statusChangeUserId
        statusRemark
        updatingDateTime
        userId
      }
    }
  }
`;
export const dayTypeApIgetHasHolidays = /* GraphQL */ `
  query DayTypeApIgetHasHolidays(
    $dayTypeId: Int!
    $resourceId: Int!
    $fromDate: String!
    $toDate: String!
    $status: String!
  ) {
    dayTypeAPIgetHasHolidays(
      dayTypeId: $dayTypeId
      resourceId: $resourceId
      fromDate: $fromDate
      toDate: $toDate
      status: $status
    ) {
      hasHolidaySchedule
    }
  }
`;
export const tourApIgetCreateTourPreReq = /* GraphQL */ `
  query TourApIgetCreateTourPreReq(
    $dayTypeId: Int!
    $resourceId: Int!
    $date: String!
    $userId: Int!
  ) {
    tourAPIgetCreateTourPreReq(
      dayTypeId: $dayTypeId
      resourceId: $resourceId
      date: $date
      userId: $userId
    ) {
      resourceDayType {
        status
        counter
        data {
          resourceDayTypeId
          isDisabled
          resourceId
          date
          dayTypeId
          scheduledDayTypeId
          approved
          approvedTimeStamp
          comment
          myComment
          daysRequestId
          originalDayTypeId
          createdDateTime
          updatingDateTime
          updatingUserId
          unionId
          contractId
          contractRulesGroupId
          contractRuleId
          salaryLevelId
          IPAddress
          TKComment
          addAuto
          postTK
          jobSalaryId
          sentDate
          rate
          hourlyActivityRateFlag
          jobSalaryUpgradeId
        }
      }
      resourcePersonnelData {
        status
        counter
        data {
          resourceId
          isDisabled
          name
          departmentId
          branchId
          divisionId
          resourceType
          unionId
          contractId
          rulesGRP
          hourlyActivityFlag
          rate
          jobSalaryId
        }
      }
      dayType {
        status
        counter
        data {
          dayTypeId
          isDisabled
          dayTypeName
          dayTypeCode
          CFEDayCode
          goldenTime
          excessiveTime
          dayKind
          sortOrder
          allowTourScheduling
          approvalNeeded
          sickTime
          isDefault
          personalBusiness
          remote
          showInRequest
          requestedOff
          training
          include
          needsRule
          dayTypeDescription
          showInSchedule
          showInCalendar
          tourColor
          sendEmail
          sendEmailTaken
          vacationPlanner
          onlyDayInfoSchedule
          showResourceComment
          consecutiveDays
          forceTour
          company
          penaltyId
          allowTourExtension
          TKDayCode
          payTransactionId
          sendToTK
          requireActHours
          updatingUserId
          updatingDateTime
          autoApprovedForTK
          countOTWeek
          isPaid
          showInCostingReport
        }
      }
      dayTypeMyComment {
        status
        myComment
      }
    }
  }
`;
export const tourApIgetActiveTours = /* GraphQL */ `
  query TourApIgetActiveTours(
    $resourceId: Int!
    $startTime: String!
    $timeZoneId: Int!
  ) {
    tourAPIgetActiveTours(
      resourceId: $resourceId
      startTime: $startTime
      timeZoneId: $timeZoneId
    ) {
      status
      counter
      data {
        tourId
        resourceType
        timeZoneId
        reconciled
        dateTimeStartActual
        dateTimeEndActual
        salaryLevelId
      }
    }
  }
`;
export const tourApIgetDefaultTourLength = /* GraphQL */ `
  query TourApIgetDefaultTourLength(
    $relatedServiceId: Int!
    $startTime: String!
    $resourceId: Int!
    $serviceId: Int!
  ) {
    tourAPIgetDefaultTourLength(
      relatedServiceId: $relatedServiceId
      startTime: $startTime
      resourceId: $resourceId
      serviceId: $serviceId
    ) {
      status
      tourLength
    }
  }
`;
export const tourApIgetTour = /* GraphQL */ `
  query TourApIgetTour($resourceId: Int!, $startDate: String!) {
    tourAPIgetTour(resourceId: $resourceId, startDate: $startDate) {
      status
      tourId
      data {
        salaryLevelId
        showBusy
        tkComment
        comment
        comment15
        approverComment
        iPAddress
        notification
        unionId
        contractId
        contractRulesGroupId
        timeZoneId
        reconciled
        costCenterId
        doLog
        contractUpdateInfo
        isSimulation
        wBSId
        baseRateId
        baseOverrideType
        baseOverride
        jobSalaryId
        hyphenateAgreementId
        jobSalaryUpgradeId
      }
    }
  }
`;
export const tourApIgetActivityFlagByTour = /* GraphQL */ `
  query TourApIgetActivityFlagByTour($tourId: Int!) {
    tourAPIgetActivityFlagByTour(tourId: $tourId) {
      status
      counter
      data {
        id
        name
      }
    }
  }
`;
export const tourApIgetTourActivityFlags = /* GraphQL */ `
  query TourApIgetTourActivityFlags($tourId: Int!) {
    tourAPIgetTourActivityFlags(tourId: $tourId) {
      status
      counter
      data {
        id
        name
        activityFlagId
        startTime
        endTime
        duration
        tourFlagId
        jobNumber
      }
    }
  }
`;
export const tourApIgetCodesByIndicator = /* GraphQL */ `
  query TourApIgetCodesByIndicator($indicatorId: Int!) {
    tourAPIgetCodesByIndicator(indicatorId: $indicatorId) {
      status
      counter
      data {
        id
        codeGroupId
        name
        description
        orderIdx
        TKCodeId
        createdUserId
        createdDateTime
        updatingUserId
        updatingDateTime
        isDisabled
        id2
        codeGroup3
        name4
        description5
        createdUserId6
        createdDateTime7
        updatingUserId8
        updatingDateTime9
        isDisabled10
        TKIndicatorId
        type
        payTransactionCode
        payTransactionDescription
        cost
        billable
        id11
        name12
        description13
        TKCodeGroupId
        createdUserId14
        createdDateTime15
        updatingUserId16
        updatingDateTime17
        isDisabled18
      }
    }
  }
`;
export const tourApIgetIndicatorsById = /* GraphQL */ `
  query TourApIgetIndicatorsById($indicatorId: Int!) {
    tourAPIgetIndicatorsById(indicatorId: $indicatorId) {
      status
      counter
      data {
        id
        codeGroupId
        name
        description
        createdUserId
        createdDateTime
        updatingUserId
        updatingDateTime
        isDisabled
        TKIndicatorId
        type
        payTransactionCode
        payTransactionDescription
        cost
        billable
      }
    }
  }
`;
export const tourApIgetIndicatorsByTour = /* GraphQL */ `
  query TourApIgetIndicatorsByTour($tourId: Int!) {
    tourAPIgetIndicatorsByTour(tourId: $tourId) {
      status
      counter
      data {
        id
        codeGroupId
        name
        description
        createdUserId
        createdDateTime
        updatingUserId
        updatingDateTime
        isDisabled
        TKIndicatorId
        type
        payTransactionCode
        payTransactionDescription
        cost
        billable
      }
    }
  }
`;
export const tourApIgetJobElementsByTour = /* GraphQL */ `
  query TourApIgetJobElementsByTour($tourId: Int!) {
    tourAPIgetJobElementsByTour(tourId: $tourId) {
      status
      counter
      data {
        id
        client
        rowCount
        jobNumber
        service
        startActual
        endActual
        jobId
        status
        projectName
        costObjectName
        costObjectId
        costObjectTypeId
        approve
      }
    }
  }
`;
export const tourApIgetTourMeals = /* GraphQL */ `
  query TourApIgetTourMeals($tourId: Int!) {
    tourAPIgetTourMeals(tourId: $tourId) {
      status
      counter
      data {
        id
        isDisabled
        tourId
        jobElementId
        dateTimeStartActual
        dateTimeEndActual
        OTE
        billable
        autoAdd
        updatingDateTime
        updatingUserId
        doLog
        IPAddress
        mealId
        jobNumber
      }
    }
  }
`;
export const tourApIgetPayTransactionsByTour = /* GraphQL */ `
  query TourApIgetPayTransactionsByTour($tourId: Int!) {
    tourAPIgetPayTransactionsByTour(tourId: $tourId) {
      status
      counter
      data {
        id
        isDisabled
        name
        code
        type
        hoursUnits
        usage
        kind
        standardHours
        flatAmount
        updatingUserId
        updatingDateTime
        allowIllegalMeal
        waiveIndicator
        primaryEC
        secondaryEC
        baseRate
        explicitUnits
        primaryUnitsFrom
        primaryUnitsTo
        secondaryUnitsFrom
        secondaryUnitsTo
        warningBillable
        warningBillableName
      }
    }
  }
`;
export const tourApIgetTourActivityFlag = /* GraphQL */ `
  query TourApIgetTourActivityFlag($tourActivityFlagId: Int!) {
    tourAPIgetTourActivityFlag(tourActivityFlagId: $tourActivityFlagId) {
      status
      counter
      data {
        id
        isDisabled
        tourId
        activityFlagId
        jobElementId
        startTime
        endTime
        updatingUserId
        updatingDateTime
        IPAddress
        doLog
      }
    }
  }
`;
export const tourApIgetTourIndicator = /* GraphQL */ `
  query TourApIgetTourIndicator($tourIndicatorId: Int!) {
    tourAPIgetTourIndicator(tourIndicatorId: $tourIndicatorId) {
      status
      counter
      data {
        id
        codeId
        indicatorId
        tourId
        updatingUserId
        updatingDateTime
        isDisabled
        doLog
        tourPayTransactionId
        billable
        jobElementId
        cost
      }
    }
  }
`;
export const tourApIgetTourIndicators = /* GraphQL */ `
  query TourApIgetTourIndicators($tourId: Int!) {
    tourAPIgetTourIndicators(tourId: $tourId) {
      status
      counter
      data {
        id
        indicatorName
        codeName
        codeId
        indicatorId
        assignment
        cost
      }
    }
  }
`;
export const tourApIgetTourExists = /* GraphQL */ `
  query TourApIgetTourExists(
    $resourceId: Int!
    $fromDates: String!
    $tillDates: String!
  ) {
    tourAPIgetTourExists(
      resourceId: $resourceId
      fromDates: $fromDates
      tillDates: $tillDates
    ) {
      status
      counter
      data {
        tourExists
      }
    }
  }
`;
export const tourApIgetTourPayTransactions = /* GraphQL */ `
  query TourApIgetTourPayTransactions($tourId: Int!) {
    tourAPIgetTourPayTransactions(tourId: $tourId) {
      status
      counter
      data {
        id
        code
        name
        assignment
        cost
        flatAmount
        type
      }
    }
  }
`;
export const tourApIgetTourPayTransaction = /* GraphQL */ `
  query TourApIgetTourPayTransaction($tourPayTransactionId: Int!) {
    tourAPIgetTourPayTransaction(tourPayTransactionId: $tourPayTransactionId) {
      status
      counter
      data {
        id
        isDisabled
        tourId
        payTransactionId
        units
        jobElementId
        waived
        billable
        internalRemark
        remark
        timeKeeperComment
        updatingUserId
        updatingDateTime
        IPAddress
        baseRate
        baseOverrides
        overrideType
        OTLength
      }
    }
  }
`;
export const tourApIgetIfToursAreInDateRange = /* GraphQL */ `
  query TourApIgetIfToursAreInDateRange(
    $resourceId: Int!
    $fromDate: String!
    $toDate: String!
  ) {
    tourAPIgetIfToursAreInDateRange(
      resourceId: $resourceId
      fromDate: $fromDate
      toDate: $toDate
    ) {
      status
      counter
      data {
        tourCounter
        tourApproved
        jeCounter
        jeApproved
      }
    }
  }
`;
export const mealApIgetMeal = /* GraphQL */ `
  query MealApIgetMeal($mealId: String!) {
    mealAPIgetMeal(mealId: $mealId) {
      status
      counter
      data {
        id
        isDisabled
        tourId
        jobElementId
        startTime
        endTime
        OTE
        billable
        autoAdd
        updatingDateTime
        updatingUserId
        doLog
        IPAddress
      }
    }
  }
`;
export const assignmentApIgetRelevantJobs = /* GraphQL */ `
  query AssignmentApIgetRelevantJobs($startTime: String!, $userId: Int!) {
    assignmentAPIgetRelevantJobs(startTime: $startTime, userId: $userId) {
      status
      counter
      data {
        name
        clientName
        id
        isDisabled
        GTitle
        jobNumber
        costObjectName
        costObjectId
        costObjectTypeId
      }
    }
  }
`;
export const assignmentApIgetRelevantJobsForCostObject = /* GraphQL */ `
  query AssignmentApIgetRelevantJobsForCostObject(
    $startTime: String!
    $userId: Int!
    $costObjectId: Int!
    $costObjectTypeId: Int!
  ) {
    assignmentAPIgetRelevantJobsForCostObject(
      startTime: $startTime
      userId: $userId
      costObjectId: $costObjectId
      costObjectTypeId: $costObjectTypeId
    ) {
      status
      counter
      data {
        name
        clientName
        id
        isDisabled
        GTitle
        jobNumber
        costObjectName
        costObjectId
        costObjectTypeId
      }
    }
  }
`;
export const assignmentApIgetActivityTypes = /* GraphQL */ `
  query AssignmentApIgetActivityTypes(
    $relatedServiceId: Int!
    $referenceDate: String!
  ) {
    assignmentAPIgetActivityTypes(
      relatedServiceId: $relatedServiceId
      referenceDate: $referenceDate
    ) {
      status
      counter
      data {
        activityType
        straightTime
        overTime
        description
        rates
      }
    }
  }
`;
export const assignmentApIgetRelatedBranches = /* GraphQL */ `
  query AssignmentApIgetRelatedBranches($userId: Int!) {
    assignmentAPIgetRelatedBranches(userId: $userId) {
      status
      counter
      data {
        name
        sameCompany
        id
        isDisabled
        companyId
        timeZoneId
      }
    }
  }
`;
export const assignmentApIgetServicesByDate = /* GraphQL */ `
  query AssignmentApIgetServicesByDate(
    $branchId: Int!
    $resourceId: Int!
    $startTime: String!
    $endTime: String!
    $priceMethodId: Int!
    $groupId: Int!
    $timeZoneId: Int!
  ) {
    assignmentAPIgetServicesByDate(
      branchId: $branchId
      resourceId: $resourceId
      startTime: $startTime
      endTime: $endTime
      priceMethodId: $priceMethodId
      groupId: $groupId
      timeZoneId: $timeZoneId
    ) {
      status
      counter
      data {
        name
        id
        salaryLevelId
        relatedServiceId
        cost
        salaryHourlyRate
      }
    }
  }
`;
export const assignmentApIgetCostObjects = /* GraphQL */ `
  query AssignmentApIgetCostObjects(
    $costObjectName: String
    $costObjectNumber: String
    $onlyValidItems: Boolean!
    $requestDate: String!
    $category: Int
    $findBy: Int
    $pageNo: Int
  ) {
    assignmentAPIgetCostObjects(
      costObjectName: $costObjectName
      costObjectNumber: $costObjectNumber
      onlyValidItems: $onlyValidItems
      requestDate: $requestDate
      category: $category
      findBy: $findBy
      pageNo: $pageNo
    ) {
      status
      counter
      rowCount
      data {
        rowIdTot
        rowId
        name
        costObjectNumber
        costObjectId
        costObjectType
        wbsElementCategory
      }
    }
  }
`;
export const assignmentApIgetGroupsByBranchAndResource = /* GraphQL */ `
  query AssignmentApIgetGroupsByBranchAndResource(
    $branchId: Int!
    $resourceId: Int!
  ) {
    assignmentAPIgetGroupsByBranchAndResource(
      branchId: $branchId
      resourceId: $resourceId
    ) {
      status
      counter
      data {
        id
        name
        isDisabled
        companyId
      }
    }
  }
`;
export const assignmentApIgetServiceSalaryLevel = /* GraphQL */ `
  query AssignmentApIgetServiceSalaryLevel($serviceId: Int!) {
    assignmentAPIgetServiceSalaryLevel(serviceId: $serviceId) {
      status
      name
    }
  }
`;
export const assignmentApIgetServicePrimaryRate = /* GraphQL */ `
  query AssignmentApIgetServicePrimaryRate($serviceId: Int!) {
    assignmentAPIgetServicePrimaryRate(serviceId: $serviceId) {
      status
      primaryRate
    }
  }
`;
export const assignmentApIgetJobSalariesByService = /* GraphQL */ `
  query AssignmentApIgetJobSalariesByService(
    $serviceId: Int!
    $startTime: String!
  ) {
    assignmentAPIgetJobSalariesByService(
      serviceId: $serviceId
      startTime: $startTime
    ) {
      status
      counter
      data {
        id
        name
        isDisabled
        contractRulesId
        effectiveDate
        expiryDate
        wageScheduleId
        wageSchedule
        primaryRate
        secondaryRate
        isByFeed
        updateDateTime
        updatingUserId
        TKJobCode
        lastUpdateDate
        job180DaysRule
      }
    }
  }
`;
export const assignmentApIgetValidateEmptyJob = /* GraphQL */ `
  query AssignmentApIgetValidateEmptyJob($assignmentId: Int!) {
    assignmentAPIgetValidateEmptyJob(assignmentId: $assignmentId) {
      status
      jobId
      message
    }
  }
`;
export const assignmentApIgetJobElement = /* GraphQL */ `
  query AssignmentApIgetJobElement($jobElementId: Int!) {
    assignmentAPIgetJobElement(jobElementId: $jobElementId) {
      status
      counter
      data {
        id
        isDisabled
        tourId
        jobId
        executingBranchId
        serviceId
        resourceId
        relatedServiceId
        status
        startRequest
        endRequest
        startActual
        endActual
        upgrade
        timeZoneId
        orderingUserId
        schedulerComment
        employerComment
        comment
        updatingDateTime
        updatingUserId
        activityCode
        approvalComment
        creatingDateTime
        isNewPlacement
        activityType
        costObjectId
        costObjectTypeId
        jobSalaryUpgradeId
        postTK
        isAnUpgrade
        rate
        collectionId
        elementId
        secondApproval
        overtimeType
        overtimeReason
      }
    }
  }
`;
export const assignmentApIgetJob = /* GraphQL */ `
  query AssignmentApIgetJob($jobId: Int!) {
    assignmentAPIgetJob(jobId: $jobId) {
      status
      counter
      data {
        id
        name
        isDisabled
        jobNumber
        subNumber
        companyId
        creatingDateTime
        creatingUserId
        updatingDateTime
        updatingUserId
        masterJobId
        startRequest
        endRequest
        clientId
        projectId
        cancelMode
        GTitle
        GAdditionalInformation
        GSchedulerComments
        GReasonForCancellation
        baseDate
        costObjectId
        costObjectTypeId
      }
    }
  }
`;
export const assignmentApIgetCostObject = /* GraphQL */ `
  query AssignmentApIgetCostObject(
    $costObjectId: Int!
    $costObjectTypeId: Int!
  ) {
    assignmentAPIgetCostObject(
      costObjectId: $costObjectId
      costObjectTypeId: $costObjectTypeId
    ) {
      status
      counter
      data {
        costObjectName
        costObjectType
        costObjectNumber
      }
    }
  }
`;
export const assignmentApIgetJobElementsWithDetails = /* GraphQL */ `
  query AssignmentApIgetJobElementsWithDetails($jobId: Int!) {
    assignmentAPIgetJobElementsWithDetails(jobId: $jobId) {
      status
      counter
      data {
        cost
        rateCardCost
        facilityCount
        results {
          rowNumber
          id
          jobId
          tourId
          salaryLevelPrice1
          activityCodePrice1
          facilityActivityCodePrice
          isDisabled
          executingBranchId
          firstInPackageJobElementId
          serviceId
          resourceId
          quantity
          relatedServiceId
          status
          startRequest
          endRequest
          startActual
          endActual
          upgrade
          salaryLevelPrice
          activityCodePrice
          timeZoneId
          approverId
          orderingUserId
          schedulerComment
          employeeComment
          comment
          updatingUserId
          jobCancelMode
          originalPackageId
          overTime
          notBilled
          doLog
          approverComment
          JEFacilityId
          JEFacilityRSId
          SBOrder
          facilityActivityCode
          facilityNightActivityCode
          isNewPlacement
          activityType
          facilityActivityType
          costObjectId
          costObjectTypeId
          jobSalaryUpgradeId
          isAnUpgrade
          rate
          hourlyActivityRateFlag
          collectionId
          elementId
          serviceName
          resourceName
          facilityName
          groupName
          packageName
          quantityStr
          approved
          length
          type
          costCenter
          STHrs
          OTHrs
          minUnit
          prorate
          STRate
          OTRate
          STProrate
          OTProrate
        }
      }
    }
  }
`;
export const assignmentApIgetService = /* GraphQL */ `
  query AssignmentApIgetService($serviceId: Int!) {
    assignmentAPIgetService(serviceId: $serviceId) {
      status
      counter
      data {
        id
        name
        isDisabled
        groupId
        availabilityChecking
        description
        type
      }
    }
  }
`;
export const assignmentApIgetGroupsByBranchInCompany = /* GraphQL */ `
  query AssignmentApIgetGroupsByBranchInCompany($branchId: Int!) {
    assignmentAPIgetGroupsByBranchInCompany(branchId: $branchId) {
      status
      counter
      data {
        id
        name
        isDisabled
        companyId
        upperName
      }
    }
  }
`;
export const assignmentApIgetAssignmentServicesByGroup = /* GraphQL */ `
  query AssignmentApIgetAssignmentServicesByGroup(
    $groupId: Int!
    $serviceId: Int!
  ) {
    assignmentAPIgetAssignmentServicesByGroup(
      groupId: $groupId
      serviceId: $serviceId
    ) {
      status
      counter
      data {
        id
        name
        isDisabled
        groupId
        availabilityChecking
        description
        type
      }
    }
  }
`;
export const assignmentApIgetServicesByGroup = /* GraphQL */ `
  query AssignmentApIgetServicesByGroup($groupId: Int!, $serviceId: Int!) {
    assignmentAPIgetServicesByGroup(groupId: $groupId, serviceId: $serviceId) {
      status
      counter
      data {
        id
        name
        isDisabled
        groupId
        availabilityChecking
        description
        type
      }
    }
  }
`;
export const assignmentApIgetApprovedJobElements = /* GraphQL */ `
  query AssignmentApIgetApprovedJobElements($jobId: Int!) {
    assignmentAPIgetApprovedJobElements(jobId: $jobId) {
      status
      counter
      data {
        id
      }
    }
  }
`;
export const assignmentApIgetJobElements = /* GraphQL */ `
  query AssignmentApIgetJobElements($jobId: Int!) {
    assignmentAPIgetJobElements(jobId: $jobId) {
      status
      counter
      data {
        rowNumber
        id
        isDisabled
        tourId
        jobId
        executingBranchId
        firstInPackageJobElement
        serviceId
        resourceId
        quantity
        relatedServiceId
        status
        startRequest
        endRequest
        startActual
        endActual
        upgrade
        timeZoneId
        approvedDateTime
        approverId
        orderingUserId
        viewed
        schedulerComment
        employeeComment
        descriptionComment
        updatingDateTime
        updatingUserId
        jobCancelMode
        originalPackageId
        overTime
        notBilled
        doLog
        activityCode
        clientId
        projectId
        approverComment
        isSimulation
        IPAddress
        location
        overTimeType
        overTimeReason
        JEFacilityId
        JEFacilityRSId
        SBOrder
        subJE
        facilityActivityCode
        facilityNightActivityCode
        creatingDateTime
        isNewPlacement
        activityType
        facilityActivityType
        costObjectId
        costObjectTypeId
        jobSalaryUpgradeId
        postTK
        isAnUpgrade
        sentDate
        rate
        hourlyActivityRateFlag
        collectionId
        elementId
        secondApproval
        nabetTracker
        eventNote
        skillShowId
        skillFacilityId
        chgTz
      }
    }
  }
`;
export const approvalsApIgetBranchesByCompanyId = /* GraphQL */ `
  query ApprovalsApIgetBranchesByCompanyId($companyId: Int!) {
    approvalsAPIgetBranchesByCompanyId(companyId: $companyId) {
      status
      count
      data {
        id
        name
        isDisabled
        companyId
        timeZoneId
      }
    }
  }
`;
export const approvalsApIgetDivisionsByBranchId = /* GraphQL */ `
  query ApprovalsApIgetDivisionsByBranchId($branchId: Int!) {
    approvalsAPIgetDivisionsByBranchId(branchId: $branchId) {
      status
      count
      data {
        id
        name
        isDisabled
        branchId
      }
    }
  }
`;
export const approvalsApIgetDepartmentsByCompanyIdBranchIdDivisionId = /* GraphQL */ `
  query ApprovalsApIgetDepartmentsByCompanyIdBranchIdDivisionId(
    $companyId: Int!
    $branchId: Int!
    $divisionId: Int!
    $withCBCode: Boolean!
  ) {
    approvalsAPIgetDepartmentsByCompanyIdBranchIdDivisionId(
      companyId: $companyId
      branchId: $branchId
      divisionId: $divisionId
      withCBCode: $withCBCode
    ) {
      status
      count
      data {
        name
        id
        name2
        isDisabled
        companyId
        branchId
        divisionId
        activityCode
        chargeBackCode
        pamCode
        costCenter
        startDate
        endDate
        sapCreatedDate
        sapCreatedBy
        posting
        sapDepartment
        costCenterGroup
        activityType
        responsibleName
        responsiblePhone
        createdDateTime
        updatedDateTime
      }
    }
  }
`;
export const approvalsApIgetResourceCollectionsByUserIdGeneralIdCompanyId = /* GraphQL */ `
  query ApprovalsApIgetResourceCollectionsByUserIdGeneralIdCompanyId(
    $userId: Int!
    $companyId: Int!
    $branchId: Int!
    $withNegativeId: Boolean!
    $addBranchInName: Boolean!
  ) {
    approvalsAPIgetResourceCollectionsByUserIdGeneralIdCompanyId(
      userId: $userId
      companyId: $companyId
      branchId: $branchId
      withNegativeId: $withNegativeId
      addBranchInName: $addBranchInName
    ) {
      status
      count
      data {
        name
        idType
        isDefaultBranch
        id
        isDisabled
        name2
        userId
        companyId
        branchId
        objId
        objType
        sentToSap
        sentToTk
        updatingDateTime
        updatingUserId
        doLog
      }
    }
  }
`;
export const approvalsApIgetTourApprovals = /* GraphQL */ `
  query ApprovalsApIgetTourApprovals(
    $fromDate: String!
    $tillDate: String!
    $branchId: Int!
    $divisionId: Int!
    $departmentId: Int!
    $by: Int!
    $rcId: Int!
    $filter: String!
    $orderBy: Int!
    $jobId: Int!
    $resourceId: Int!
    $userId: Int!
    $showAssignments: Boolean!
    $orderByDep: Boolean!
    $clientId: Int!
    $projectId: Int!
    $showDayTypes: Boolean!
    $costObjectId: Int!
    $costObjectTypeId: Int!
  ) {
    approvalsAPIgetTourApprovals(
      fromDate: $fromDate
      tillDate: $tillDate
      branchId: $branchId
      divisionId: $divisionId
      departmentId: $departmentId
      by: $by
      rcId: $rcId
      filter: $filter
      orderBy: $orderBy
      jobId: $jobId
      resourceId: $resourceId
      userId: $userId
      showAssignments: $showAssignments
      orderByDep: $orderByDep
      clientId: $clientId
      projectId: $projectId
      showDayTypes: $showDayTypes
      costObjectId: $costObjectId
      costObjectTypeId: $costObjectTypeId
    ) {
      status
      counter
      data {
        approverComment
        baseOverride
        baseOverrideType
        contractRulesGroupId
        dayEnd
        dayStart
        dayType
        department
        departmentId
        isSalaryLevelDisabled
        isSalaryLevelUDisabled
        jobSalaryUpgrade
        lastName
        name
        notification
        penaltyId
        penaltyName
        postTK
        rdtComment
        rdtId
        rdtMyComment
        reconciled
        resourceId
        salaryLevel
        sso
        tourApprovedDateTime
        tourComment
        tourComment15
        tourId
        updatingTimeStamp
        updatingUserName
        upgrade
        meals {
          mealDepartment
          mealEnd
          mealId
          mealLastName
          mealStart
          resourceId
          tourId
          tourStartDate
        }
        serviceOrders {
          activityCode
          activityType
          approved
          approvedDateTime
          approverComment
          assignmentResourceId
          budgetCode
          client
          costObjectId
          costObjectName
          costObjectNumber
          costObjectTypeId
          costObjectTypeName
          department
          description
          employeeComment
          employeeComment1
          endActual
          endRequest
          isActivityCodeExists
          isSalaryLeveldisabled
          jobId
          jobNumber
          lastName
          notBilled
          project
          reconciled
          salaryLevel
          schedulerComment
          service
          serviceId
          startActual
          startRequest
          status
          statusInt
          tourId
          tourStartDate
          updateDateTime
          upgrade
          userName
        }
        payTransactions {
          department
          lastName
          payTransaction
          payTransactionResourceId
          tourId
          tourStartDate
        }
        indicators {
          department
          indicator
          indicatorResourceId
          lastName
          tourId
          tourStartDate
        }
      }
    }
  }
`;
export const approvalsApIgetContactInfoCheckByTourId = /* GraphQL */ `
  query ApprovalsApIgetContactInfoCheckByTourId($tourId: Int!) {
    approvalsAPIgetContactInfoCheckByTourId(tourId: $tourId) {
      status
      data
    }
  }
`;
export const approvalsApIgetResourceDayTypeIdByDateAndResourceId = /* GraphQL */ `
  query ApprovalsApIgetResourceDayTypeIdByDateAndResourceId(
    $resourceId: Int!
    $date: String!
  ) {
    approvalsAPIgetResourceDayTypeIdByDateAndResourceId(
      resourceId: $resourceId
      date: $date
    ) {
      status
      data {
        Id
      }
    }
  }
`;
export const approvalsApIgetTimeKeeperReversalCheckByTourId = /* GraphQL */ `
  query ApprovalsApIgetTimeKeeperReversalCheckByTourId($ids: String!) {
    approvalsAPIgetTimeKeeperReversalCheckByTourId(ids: $ids) {
      status
      data
    }
  }
`;
export const approvalsApIgetTourIsDirectBillingCheckByTourId = /* GraphQL */ `
  query ApprovalsApIgetTourIsDirectBillingCheckByTourId($tourId: Int!) {
    approvalsAPIgetTourIsDirectBillingCheckByTourId(tourId: $tourId) {
      status
      data
    }
  }
`;
export const systemApIgetHealthCheck = /* GraphQL */ `
  query SystemApIgetHealthCheck {
    systemAPIgetHealthCheck {
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js